import AutocompleteChips from './AutocompleteChips';

export default AutocompleteChips;
